

















import { Component, Prop, Vue } from "@/shared/vuepack";
import { Address, HsabExpenseResponse } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useContactInfoStore } from "@/shared/store/contactinfo";

@Component({})
export default class HsbExpenseCardRowPayee extends Vue {
  userStore = useUserStore();
  contactInfoStore = useContactInfoStore();

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  get nameToDisplay () {
    if (this.expense.isPayToPayee) {
      return this.expense.payeeName;
    } else {
      return this.userStore.displayName;
    }
  }

  get accountToDisplay () {
    if (this.expense.isPayToPayee) {
      return this.expense.payeeMemberNumber;
    } else {
      return "";
    }
  }

  get addressToDisplay (): Address {
    let result: Address = {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: ""
    };
    if (this.expense.isPayToPayee) {
      result.addressLine1 = this.expense.payeeAddress1;
      result.addressLine2 = this.expense.payeeAddress2;
      result.city = this.expense.payeeCity;
      result.state = this.expense.payeeStateCode;
      result.zip = this.expense.payeeZipCode;
    } else if (this.contactInfoStore.contactInformation
        && this.contactInfoStore.contactInformation.mailingAddress) {
      result = this.contactInfoStore.contactInformation.mailingAddress;
    }

    return result;
  }
}
